// extracted by mini-css-extract-plugin
export default {"showSpinner":"ButtonWithSpinner__showSpinner","spinner":"ButtonWithSpinner__spinner","rotation":"ButtonWithSpinner__rotation","label":"ButtonWithSpinner__label"};